
import { Component, Vue } from 'vue-property-decorator';
import AboutButton from './AboutButton.vue';

@Component({
  components: {
    AboutButton
  }
})
export default class InfoButtons extends Vue {}
